<template>
  <ErrorPageTemplate>
    Этой страницы больше нет. Либо она была<br />перемещена, либо вовсе не существовала.<br /><br />
    Вот тебе и отдохнули культурно...
  </ErrorPageTemplate>
</template>

<script setup lang="ts">
import { ErrorPageTemplate } from '@/6_shared/ui'
</script>
